import moment from 'moment';

import { ObligationFile } from '../operations/file/types';
import { isPaymentRequired } from './isPaymentRequired';

export const getFilteredFiles = (files: ObligationFile[]) => {
  const expiredFiles: ObligationFile[] = [];
  const visualizedFiles: ObligationFile[] = [];
  const unviewedFiles: ObligationFile[] = [];

  files.forEach((file) => {
    const isPastDue = moment(file.due_at).isBefore(moment(), 'dates');
    const isNotViewed = !file.viewed_at;
    const requiresPayment = isPaymentRequired(file.requires_payment);

    if (isPastDue && isNotViewed && requiresPayment) {
      expiredFiles.push(file);
    } else if (file.viewed_at) {
      visualizedFiles.push(file);
    } else {
      unviewedFiles.push(file);
    }
  });

  return {
    expiredFiles,
    visualizedFiles,
    unviewedFiles,
  };
};
